import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const getShippingPartnerId = createAction(ACTION.GET_SHIPPING_PARTNER_ID, data => data);
export const editShippingPartner = createAction(ACTION.EDIT_SHIPPING_PARTNER.REQUEST, data => data);
export const editShippingDomesticPartner = createAction(ACTION.EDIT_SHIPPING_DOMESTIC_PARTNER.REQUEST, data => data)
